import type { IconNode } from '../types';

/**
 * @name soap-bar
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuMyAyLjdjLjktLjkgMi41LS45IDMuNCAwbDUuNiA1LjZjLjkuOS45IDIuNSAwIDMuNGwtOC42IDguNmMtLjkuOS0yLjUuOS0zLjQgMGwtNS42LTUuNmMtLjktLjktLjktMi41IDAtMy40WiIgLz4KICA8cGF0aCBkPSJtMTMgNy02IDYgMyAzIDYtNloiIC8+CiAgPGNpcmNsZSBjeD0iMjAuNSIgY3k9IjE3LjUiIHI9Ii41IiAvPgogIDxjaXJjbGUgY3g9IjE3LjUiIGN5PSIyMS41IiByPSIuNSIgLz4KICA8cGF0aCBkPSJNMjIgMjJoLjAxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/soap-bar
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const soapBar: IconNode = [
  [
    'path',
    {
      d: 'M11.3 2.7c.9-.9 2.5-.9 3.4 0l5.6 5.6c.9.9.9 2.5 0 3.4l-8.6 8.6c-.9.9-2.5.9-3.4 0l-5.6-5.6c-.9-.9-.9-2.5 0-3.4Z',
      key: 'pjvvcq',
    },
  ],
  ['path', { d: 'm13 7-6 6 3 3 6-6Z', key: '16w136' }],
  ['circle', { cx: '20.5', cy: '17.5', r: '.5', key: '1ithnu' }],
  ['circle', { cx: '17.5', cy: '21.5', r: '.5', key: '3d4p64' }],
  ['path', { d: 'M22 22h.01', key: 'vsn7bk' }],
];

export default soapBar;
